import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 3a1 1 0 0 0 0 2a5 5 0 0 1 5 5a1 1 0 0 0 2 0a7 7 0 0 0 -7 -7z","key":"svg-0"}]]

const IconInnerShadowTopRightFilled = createReactComponent('filled', 'inner-shadow-top-right-filled', 'InnerShadowTopRightFilled', __iconNode);

export default IconInnerShadowTopRightFilled;